import React, { useEffect, useState } from 'react';
// import logo from './logo.svg';
import './App.css';
import { createClient } from '@supabase/supabase-js';
import { Purchases } from "@revenuecat/purchases-js";

// const appUserId = Purchases.generateRevenueCatAnonymousAppUserId();
// const purchases = Purchases.configure({
//     apiKey: "test_EWzZxcgWSHLPhfDYqDYVgMlcCsf",
//     appUserId: appUserId,
// });
var REACT_APP_SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL ?? ""
var REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY =  process.env.REACT_APP_SUPABASE_KEY ?? ""
const client = createClient(REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY)

function App() {
  const [textEntry, setTextEntry] = React.useState<string>("");
  const [searchTerm, setSearchTerm] = React.useState<string>("");
  const [internalSearchTerm, setInternalSearchTerm] = React.useState<string>("");
  const [editedText, setEditedText] = React.useState<string>("");
  const [windowTarget, setWindow] = React.useState<string>("");
  const [searchedValues, setSearchedValues] = React.useState<any>(null);
  const [currentPage, setCurrentPage] = React.useState<string>("myScrolls");
  const [searchedUsers, setSearchedUsers] = React.useState<any>(null);
  const [currentMembers, setCurrentMembers] = React.useState<any>(null);
  const [targetItem, setTargetItem] = React.useState<any>(null);
  const [targetMetaData, setTargetMetaData] = React.useState<any>(null);
  const [bubbles, setBubbles] = React.useState<any>(null);
  const [stats, setStats] = React.useState<any>(null);
  const [publicScroll, setPublic] = React.useState<boolean>(false);
  const [mode, setMode] = React.useState<string>("entry");
  const [colors, setColors] = React.useState<{ [key: string]: string[] }>({});
  const [color, setColor] = React.useState<string>("");
  const [bubbleData, setBubbleData] = React.useState<any[]>([]);
  const [displayMode, setDisplayMode] = useState<number>(-1);
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [session, setSession] = useState<any>(null);
  const [user, setUser] = useState<any>(null);
  const [privacy, setPrivacy] = useState<boolean>(false);


  const [journals, setJournals] = useState<any>(null);
  const [currentJournal, setCurrentJournal] = useState<any>(null);

  var userid = 1;

  // async function purchaseFunction(){

  //   const purchasesInstance = Purchases.getSharedInstance();

  //   try {
  //     const customerInfo = await purchasesInstance.getCustomerInfo();
  //     if ("scrolls Pro" in customerInfo.entitlements.active) {
  //       // Grant user access to entitlement
  //     }
  //   } catch(error) {
  //     console.error(error);
  //   }

  //   try {
  //   const offerings = await purchasesInstance.getOfferings();
  //   const currentOffering = offerings.current;
  //   if (!currentOffering) return;
  //   const purchaseResult = await purchasesInstance.presentPaywall({ offering: currentOffering });
  //   const { customerInfo, redemptionInfo } = purchaseResult;
  //   // Handle purchase result
  // } catch (error) {
  //   console.error(error);
  // }

  // }

  async function submit() {
    var d = new Date();
    // alert(d.toLocaleTimeString());
    // var [date,time] = d.toISOString().split("T");
    var [date, time] = d.toLocaleString("sv-SE").split(" ")
    var [year, month, day] = date.split("-");
    const { data, error } = await client.from("journaltomessages").insert({
      journalid: currentJournal,
      userid: user.id,
      year: parseInt(year),
      month: parseInt(month),
      day: parseInt(day),
      time: time,
      text: textEntry,
      type: mode,
      private: privacy,
      date_combined: date
    });

    if (error) {
      alert("error: " + JSON.stringify(error));
      return;
    }
    // alert("submitted: " + textEntry + " on " + day + "/" + month + "/" + year + " at " + time.slice(0,8));
    localStorage.removeItem("draft");
    loadfromDatabase();
    setTextEntry("");
  }

  async function saveLocal() {
    localStorage.setItem("draft", textEntry);
  }

  async function loadDraft() {
    var draft = localStorage.getItem("draft");
    if (draft) {
      setTextEntry(draft);
    }
  }

  async function searchLoad(targetTable:string,returnedColumns:string,targetColumn:string,tempSearchTerm:string,stateFunction:Function){
    // var tempSearchTerm = internalSearchTerm;
    // if(internalSearchTerm == ""){
    //   tempSearchTerm = " ";
    // }
    const dataBundle = await client.from(targetTable).select(returnedColumns).ilike(targetColumn, `%${tempSearchTerm}%`);
    stateFunction(dataBundle.data);
  }

  async function handleSearch(){

  }

  async function loadJournals() {
    // const {data, error} = null
    var dataBundle = null

    switch (currentPage) {
      case "myScrolls":
        dataBundle = await client.from("journalstousers").select("*").ilike("journal_name", `%${searchTerm}%`).eq("public", publicScroll).eq("ownerid", user.id);
        break;
      case "sharedScrolls":
        dataBundle = await client.from("journalstousers").select("*").ilike("journal_name", `%${searchTerm}%`).eq("public", publicScroll).neq("ownerid", user.id);
        break;
      default:
        dataBundle = await client.from("journalstousers").select("*").ilike("journal_name", `%${searchTerm}%`).eq("public", publicScroll).eq("ownerid", user.id);
    }

    if (dataBundle) {
      const { data, error } = dataBundle;
      if (error) {
        alert("error loading journals");
      } else {
        // console.log(data)
        setJournals(data);
      }
    }
  }

  async function loadfromDatabase() {
    if (user && session && currentJournal) {
      const { data, error } = await client.from("journaltomessages").select(`*`).eq("journalid", currentJournal).order("date_combined", { ascending: false }).order("time", { ascending: false }).ilike("text", `%${searchTerm}%`).limit(50);
      var d = new Date();
      var [date, time] = d.toLocaleString("sv-SE").split(" ");
      // alert(date)
      const dataBundle2 = await client.rpc('stats', { useridparameter: user.id, journalidparameter: currentJournal, dateparameter: date })
      const dataBundle3 = await client.rpc('journal_entry_sum', { journalidparameter: currentJournal })
      if (!dataBundle2.error) {
        console.log("got stats")
        console.log(dataBundle3.data)
        setStats({
          day_entries: dataBundle2.data?.[0]?.column2,
          total_entries: dataBundle3.data?.[0]?.column1
        })
      } else {
        console.log(dataBundle2.error)
      }
      if (error) {
        alert("Error loading from database:")
        console.log(error);
      }

      if (data) {
        setBubbleData(data);
      }
    }
  }

  function showStorage() {
    var storage = localStorage.getItem("draft");
    alert(storage);
  }

  useEffect(() => {
    saveLocal();
  }, [textEntry]);

  useEffect(() => {
    loadColors();
    // loadfromDatabase();
    // var d = new Date();
    // console.log(d.toLocaleString("sv-SE"))
  }, []);

  useEffect(() => {
    if (session) {

      setDisplayMode(1);
      loadJournals();
      setColor(colors[mode][1]);
      if(currentPage == "manageMembers"){
        loadUsers();
      } 

    } else {
      setDisplayMode(-1);
    }
  }, [session, searchTerm, publicScroll, currentPage])

  // useEffect(()=>{
  //   if(session){

  //   }
  // },[searchTerm])

  //FOR METADATA VIEW
  useEffect(()=>{
     loadMessageMetaData()
  },[windowTarget,searchedValues,targetItem])



  async function loadUsers(){
    if(currentJournal){
      const currentMemberBundle = await client.rpc("current_members",{ journalidparameter: currentJournal });
      if(!currentMemberBundle.error){
        console.log("Current Members")
        console.log(currentMemberBundle.data)
        setCurrentMembers(currentMemberBundle.data)
      } else {
        console.log(currentMemberBundle.error)
      }
    }

    if(searchTerm){
      const {data, error} = await client.from('user_info').select('username,user_id').ilike("username",`%${searchTerm.trimStart().trimEnd()}%`).neq("user_id",user.id);
      if(!error) {
        // alert("loadedUsers");
        // console.log(data);
        setSearchedUsers(data);
      } else {
        alert("error loading users");
      }
    } else {
      setSearchedUsers(null)
    }
  }

  function cleanUp(){
    setCurrentMembers(null);
  }

  useEffect(() => {
    if (currentJournal) {
      loadfromDatabase();
    } else {
      cleanUp();
    }
  }, [journals, currentJournal])

  useEffect(() => {
    if (currentJournal) {
      setSearchTerm("")
    }
  }, [currentJournal])

  // useEffect(() => {
  //   if (bubbleData) {
  //     textBubbles()
  //   }
  // }, [bubbleData])


  // useEffect(() => {
  //   if (targetItem) {
  //   } else {
  //     // textBubbles()
  //   }
  // }, [targetItem])

  // useEffect(() => {
  //   if (bubbleData) {
  //     textBubbles()
  //   }
  // }, [targetMetaData, editedText,internalSearchTerm,searchedValues])


  async function loadMessageMetaData() {
    if(targetItem){

    
    var { data, error } = await client.from("messagestotags").select("*").eq("message_id", targetItem.message_id);
    var tagArray: string[] = [];
    if (data) {
      data.map((item, i) => {
        tagArray.push(item)
      })
    }
    // alert(tagArray);
    setTargetMetaData(tagArray)
    }
  }


  async function loadColors() {
    var { data, error } = await client.from("message_types").select("*").order("type", { ascending: true });
    var colorMap: { [key: string]: string[] } = {};
    if (error) {
      alert("color loading error")
    }
    if (data) {
      data.map(
        (item: any) => {
          colorMap[item.type] = [item.display_color ?? "white", item.button_color, item.display_name, item.type, item.alignment];
        }
      )
    }
    console.log("loaded colors:");
    console.log(colorMap);
    setColors(colorMap);
    //   var colors:any = {
    //   "entry":"#2c3d2c22",
    //   "todo":"#0000ff22",
    //   "link":"#ff000022"
    // }
  }

  async function updateText(item: any, edited: string) {
    var oldText = item.text;
    // var edited = prompt("Edit your entry:", item.text);
    var d = new Date();
    var lastEditedDate = d.toLocaleDateString();
    var lastEditedTime = d.toLocaleTimeString();
    var lastEdited = lastEditedDate + " " + lastEditedTime;

    if (edited !== null) {
      // alert("edited: " + edited);
      const { data, error } = await client.from("journaltomessages").update({ text: edited, last_edited: lastEdited }).eq("journalid", currentJournal).eq("userid", user.id).eq("text", oldText);
      // .eq("year",item.year).eq("month",item.month).eq("day",item.day).eq("time",item.time);
      if (error) {
        alert("error: " + JSON.stringify(error));
        return;
      } else {
        alert("updated entry to: " + edited);
        loadfromDatabase();
      }
    }
  }

  async function updatePrivacy(item: any) {
    var newPrivateState: boolean = !!item.private;
    const { data, error } = await client.from("journaltomessages").update({ private: !newPrivateState }).eq("journalid", currentJournal).eq("userid", user.id).eq("year", item.year).eq("month", item.month).eq("day", item.day).eq("time", item.time);
    // .eq("year",item.year).eq("month",item.month).eq("day",item.day).eq("time",item.time);
    if (error) {
      alert("error: " + JSON.stringify(error));
      return;
    } else {
      // console.log(data)
      // alert("updated privacy");
      loadfromDatabase();
    }
  }

  // function tag(text: string) {
  //   return (<span onClick={()=>addTag(item.message_id,item2.tag)} className="tag" style={{ padding: 2, borderRadius: 5 }}>{text}</span>)
  // }

  async function addTag(message_id:string,tag:string){
    const dataBundle = await client.from("messagestotags").insert({message_id:message_id,tag:tag})
    if(dataBundle.error){
      alert("error adding tag")
    } else {
      // textBubbles()
    }
    loadMessageMetaData()
  }

  async function dropTag(message_id:string,tag:string){
    const dataBundle = await client.from("messagestotags").delete().eq("message_id",message_id).eq("tag",tag);
    if(dataBundle.error){
      alert("error deleting tag")
    } else {
      // textBubbles()
    }
    loadMessageMetaData() 
  }


  function textBubbles() {
    var bubbles: Array<any> = [];
    if (bubbleData) {
      bubbleData.map((item, index) => {
        if (item.userid == user.id) {
          // if(targetItem && item.year == targetItem.year && item.day == targetItem.day && item.month==targetItem.month && item.time == targetItem.time){
          if (targetItem == item && windowTarget == "edit") {
            bubbles.push(
              <div className="bubble" style={{ padding: "10px", margin: "10px", maxWidth: "100%" }}>
                {/* <div className="bubbleButtons"> */}
                <div />
                <div />
                <div />
                <button className="actionButton" style={{ margin: 10, padding: 10, gridColumn: "span 1" }} >Edit</button>
                <button className="actionButton" style={{ margin: 10, padding: 10 }} onClick={() => setTargetItem(null)}>Text</button>
                <button className="actionButton" style={{ margin: 10, padding: 10, gridColumn: "span 1" }} onClick={() => updatePrivacy(item)}>{item.private ? "🔒" : "🔓"}</button>
                {/* </div> */}

                <div className="bubbleContent" style={{ gridColumn: "span 6", filter: "none" }}>
                  <div style={{ textAlign: "start" }}>
                    <p style={{ color: "black", fontWeight: "bolder", fontSize: "1.5em" }}>{item.year}-{item.month}-{item.day}<br></br>{item.last_edited ? subtext(" Edited: " + item.last_edited) : ""}</p></div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 0 }}>
                    <button className="actionButton" style={{ minWidth: "100%", margin: 0 }} onClick={() => updateText(item, editedText)}>Submit Changes</button>
                    <button className="dangerButton" style={{ minWidth: "100%", margin: 0 }} onClick={() => setTargetItem(null)}>Cancel</button>
                    <textarea value={editedText} onChange={e => setEditedText(e.target.value)} style={{ minWidth: "100%", maxWidth: "100%", minHeight: "200px", gridColumn: 'span 2', boxSizing: "border-box" }}></textarea>
                  </div>

                  {/* <input type="search"></input> */}
                  {/* <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:5}}>{targetMetaData.map((item:any)=>{return(tag(item.tag + " "))})}</div> */}
                  <p>{item.last_edited}</p>
                </div>

              </div>


            )
          } else if (targetItem == item && windowTarget == "metadata") {
            bubbles.push(
              <div className="bubble" style={{ padding: "10px", margin: "10px", maxWidth: "100%" }}>
                {/* <div className="bubbleButtons"> */}
                <div />
                <div />
                <div />
                <button className="actionButton" style={{ margin: 10, padding: 10, gridColumn: "span 1" }} >Edit</button>
                <button className="actionButton" style={{ margin: 10, padding: 10 }} onClick={() => setTargetItem(null)}>Text</button>
                <button className="actionButton" style={{ margin: 10, padding: 10, gridColumn: "span 1" }} onClick={() => updatePrivacy(item)}>{item.private ? "🔒" : "🔓"}</button>

                <div className="bubbleContent" style={{ display:"grid",gridTemplateColumns:"1fr 1fr", gridColumn: "span 6", filter: "none" }}>
                  {/* <div style={{ textAlign: "start" }}>
                    <p style={{ color: "black", fontWeight: "bolder", fontSize: "1.5em" }}>{item.year}-{item.month}-{item.day}<br></br>{item.last_edited ? subtext(" Edited: " + item.last_edited) : ""}</p></div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 0 }}>
                    <button className="actionButton" style={{ minWidth: "100%", margin: 0 }} onClick={() => updateText(item, editedText)}>Submit Changes</button>
                    <button className="dangerButton" style={{ minWidth: "100%", margin: 0 }} onClick={() => setTargetItem(null)}>Cancel</button>
                    <textarea value={editedText} onChange={e => setEditedText(e.target.value)} style={{ minWidth: "100%", maxWidth: "100%", minHeight: "200px", gridColumn: 'span 2', boxSizing: "border-box" }}></textarea>
                  </div> */}


            
                  {/* <div>{searchedValues?.map((item2:any)=><div onClick={()=>alert(item.message_id)}>{tag(item2.tag)}</div>)}</div> */}
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: 5 }}>
                                                        <input type="search" style={{gridColumn:"span 5"}}value={internalSearchTerm} onChange={async e=>{setInternalSearchTerm(e.target.value); searchLoad("tags","tag","tag",e.target.value,setSearchedValues)}}></input>

                    {

                  searchedValues?.map((item2: any) => { return (
                    <span onClick={()=>addTag(item.message_id,item2.tag)} className="tag" style={{ padding: 2, borderRadius: 5 }}>{item2.tag}</span>
                  )})}</div>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: 5 }}>{targetMetaData?.map((item2: any) => { return (
                  
                  <span onClick={()=>dropTag(item.message_id,item2.tag)} className="tag" style={{ padding: 2, borderRadius: 5 }}>{item2.tag}</span>
                  
                  ) })}</div>
                  {/* <div style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: 5 }}>{searchedMetaData.map((item: any) => { return (tag(item.tag + " ")) })}</div> */}

                  <p>{item.last_edited}</p>
                </div>
              </div>
            )
          }
          else {
            bubbles.push(
              <div className="bubble" style={{ padding: "10px", margin: "10px", maxWidth: "100%" }}>
                <p style={{ alignContent: "end", fontWeight: "bolder", fontSize: "1.5em" }}>{item.year}-{item.month}-{item.day}</p>
                <div style={{ alignContent: "end" }}>{item.last_edited ? subtext(" Edited: " + item.last_edited) : ""}</div>
                <div />
                <button className="actionButton" style={{ margin: 10, padding: 10, gridColumn: "span 1" }} onClick={() => {setWindow("edit"); setTargetItem(item); setEditedText(item.text); }}>Edit</button>
                <button className="actionButton" style={{ margin: 10, padding: 10, gridColumn: "span 1" }} onClick={() => {setWindow("metadata"); setTargetItem(item);}}>Metadata</button>
                <button className="actionButton" style={{ margin: 10, padding: 10, gridColumn: "span 1" }} onClick={() => updatePrivacy(item)}>{item.private ? "🔒" : "🔓"}</button>
                <div className="bubbleContent" style={{ gridColumn: "span 6", filter: item.private ? "blur(4px)" : "none" }}>
                  <div style={{ textAlign: "start" }}>
                  </div>
                  <div>
                    <pre style={{ color: "white", textWrap: "wrap", fontSize: "1.2em", width: "60%", justifySelf: "center", textAlign: "start", whiteSpace: "pre-wrap", wordWrap: "break-word" }}>{item.text}</pre>
                  </div>
                </div>
              </div>
            );
          }
        } else if (item.userid != user.id) {
          bubbles.push(
            <div className="bubble" style={{backgroundColor:"#ffffff6a",padding: "10px", margin: "10px", maxWidth: "100%" }}>
                <p style={{alignContent: "end", fontWeight: "bolder", fontSize: "1.5em" }}>{item.username}{item.year}-{item.month}-{item.day}</p>
                <div style={{alignContent: "end" }}>{item.last_edited ? subtext(" Edited: " + item.last_edited) : ""}</div>
                <div />
                {/* <button className="actionButton" style={{ margin: 10, padding: 10, gridColumn: "span 1" }} onClick={() => { setWindow("edit"); setTargetItem(item); setEditedText(item.text); }}>Edit</button> */}
                {/* <button className="actionButton" style={{ margin: 10, padding: 10, gridColumn: "span 1" }} onClick={() => { setWindow("metadata"); setTargetItem(item); }}>Metadata</button> */}
                {/* <button className="actionButton" style={{ margin: 10, padding: 10, gridColumn: "span 1" }} onClick={() => updatePrivacy(item)}>{item.private ? "🔒" : "🔓"}</button> */}
                <div className="bubbleContent" style={{ gridColumn: "span 6", filter: item.private ? "blur(4px)" : "none" }}>
                  <div style={{ textAlign: "start" }}>
                  </div>
                  <div>
            
                    <pre style={{ color: "white", textWrap: "wrap", fontSize: "1.2em", width: "60%", justifySelf: "center", textAlign: "start", whiteSpace: "pre-wrap", wordWrap: "break-word" }}>{item.text}</pre>
                  </div>
                </div>
            </div>
          )
        }
      });



      // setBubbles(bubbles);
      return(bubbles);
    }
    else {
      return <div>No messages yet.</div>;
    }
  }


  async function toggle(mode: string) {
    setMode(mode);
    setColor(colors[mode][1]);
  }

  async function exportData() {
    const { data, error } = await client.from("journaltomessages").select(`*`).eq('journalid',currentJournal);
    if (!error) {
      const csvBlob = new Blob([convertToCSV(data)], { type: 'text/csv' });
      const url = URL.createObjectURL(csvBlob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'journaltomessages_export.csv';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }

  function convertToCSV(data: any[]) {
    const headers = Object.keys(data[0]).join(',') + '\n';
    const rows = data.map(item => Object.values(item).map(value => `"${String(value).replace(/"/g, '""')}"`).join(',')).join('\n');
    return headers + rows;
  }

  function modeButtons() {

    return (
      <div className="modeButtonContainer" style={{ maxHeight: "100px", overflowY: "scroll" }}>
        {
          Object.values(colors).map((item, index) => {
            return (<button className="modeButton" onClick={() => toggle(item[3])} style={{ backgroundColor: item[1] }}>{item[2]}</button>)
          })
        }
      </div>
    )
  }

  async function getPrompt() {
    const { data, error } = await client.from("prompts").select("prompt").eq("category", "historical")
    if (error) {
      alert("error")
      return;
    }
    if (data) {
      alert(data[Math.floor(Math.random() * data.length)].prompt)
    }
  }

  function coloredTextArea() {
    var privColor = "#ffffff"
    if (privacy) {
      privColor = "#61dafbaa"
    }

    return (
      <div className="textDisplay" style={{ display: "grid", gridTemplateColumns: "repeat(8, 1fr)", maxHeight: "50vh" }}>
        <textarea className="mainTextEntry" placeholder="Begin Typing..." value={textEntry} onChange={e => { setTextEntry(e.target.value); }} style={{
          backgroundColor: "transparent",
          width: '100%',
          gridColumn: "span 8",
          height: '20vh',
          borderTopWidth: "15px",
          borderLeftWidth: "0px",
          borderRightWidth: "0px",
          borderTopStyle: "solid",
          borderTopColor: "wheat",
          borderBottomWidth: "0px",
          // alignContent: "end",
          color: "white",
          boxSizing: "border-box",
          padding: 10,
          fontSize: "2em"

        }}>
        </textarea>

        {/* <div className="visualToggle" onClick={() => setPrivacy(!privacy)} style={{ display: "flex", flexDirection: "column", borderStyle: "solid", borderColor: "wheat", borderWidth: "10px", padding: "10px", fontSize: "4em" }}>
          {privacy ? "🔒" : "🔓"}
          <input type="checkbox" hidden style={{ height: "fit-content" }} checked={privacy} onChange={e => setPrivacy(!privacy)}></input>
        </div>

        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-around", minHeight: "100%" }}>
          <div style={{ backgroundColor: colors[mode][1], gridColumn: "span 2", minHeight: "30px", }}>Mode:

          </div>
          {modeButtons()}
          <button className="modeButton" onClick={() => exportData()} style={{ backgroundColor: colors["export"]?.[1] }}>Export</button>
        </div> */}

        <button className="actionButton" style={{ gridColumn: "span 2" }} onClick={() => submit()} >Submit</button>
        <button style={{ gridColumn: "span 2" }} className="actionButton" onClick={() => loadfromDatabase()}>Refresh</button>
        <button style={{ gridColumn: "span 2" }} className="dangerButton" onClick={() => { setCurrentJournal(null); setBubbleData([]); setSearchTerm(""); setCurrentPage("myScrolls") }} >Close Scroll</button>


      </div>
    )
  }

  function signOutButton() {
    return (<button className="actionButton" onClick={() => { setSession(null); }} >Sign Out</button>)
  }

  function mainApp() {
    return (
      <div style={{ display: "grid", gridTemplateColumns: "repeat(6,1fr)", flexDirection: "column", minHeight: "100%-100px", width: "100%", alignItems: "center" }}>
        {/* TEXT DISPLAY */}
        <div style={{
          backgroundColor: "#ffffff00", gridColumn: "span 5", maxHeight: "60vh", overflowY: "auto"
          // alignContent: "center", width: "100%", marginLeft: "0%", minHeight: "50vh", maxHeight: "50vh", overflowY: "scroll", overflowX: "hidden", border: "1px solid black", display: "flex", flexDirection: "column", marginTop: "30px" 
        }}>
          {
            textBubbles()
          }
        </div>
        {/* STATISTICS */}
        <div className="statsGrid" style={{ gridColumn: "span 1" }}>
          {/* Entries Today: {stats?.[0]?.column2} */}
          <div className="statsPackage">
            <h2>Daily Goal:</h2>
            <progress max={10} value={stats?.day_entries}></progress>
          </div>
          <div className="statsPackage">
            <h2>Total Entries:</h2>
            <p>{stats?.total_entries}</p>
          </div>
        </div>
        {/* INPUT AND CONTROLS */}
        <div style={{ gridColumn: "span 6", alignContent: "center", marginLeft: "0%" }}>
          {
            coloredTextArea()
          }
        </div>
      </div>
    )
  }

  async function signIn() {
    if (email != "" && password != "") {
      const { data, error } = await client.auth.signInWithPassword({
        email: email,
        password: password,
      });

      if (error) {
        console.log(error)
        alert("Sign in Error")
        return;
      } else {
        setUser(data.user);
        console.log("Session User data:")
        console.log(data.user);
        setSession(data.session);
        setEmail("")
        setPassword("")
      }
    } else {
      alert("Please enter username and password")
    }
  }

  async function signUp() {
    const { data, error } = await client.auth.signUp({
      email: email,
      password: password,
    })
    if (error) {
      alert("error signing up")
    } else {
      setEmail("")
      setPassword("")
    }
  }

  function subtext(text: string) {
    return <span style={{ fontSize: "0.5em", color: "gray" }}>{text}</span>
  }


  async function signUpBetaTest() {
    var d = new Date();
    const [date, time] = d.toLocaleString("sv-SE").split(" ");
    const { data, error } = await client.from("beta_testers").insert({email:email,date:date,time:time});
    if (error) {
      alert("error signing up")
    } else {
      setEmail("")
      setPassword("")
      alert("Thank you for signing up to be a beta tester!")
    }
  }



  function signInScreen() {
    return (
      <div className="signIn" style={{ height: "100vh", justifySelf:"center",alignSelf:"center", justifyContent: "center",justifyItems:"center" }}>
        <div className="appTitle">
          <h1>Scrolls{subtext("beta")}</h1>
        </div>
        <input style={{ margin: 20, padding: 5 }} placeholder="email" onChange={e => setEmail(e.target.value)}></input>
        <input type="password" style={{ margin: 20, padding: 5 }} placeholder="password" onChange={e => setPassword(e.target.value)}></input>
        <div className="signInGrid">
          <button className="actionButton" style={{ margin: 20, padding: 5 }} onClick={() => { signIn() }}>Sign In</button>
          <button className="actionButton" style={{ margin: 20, padding: 5 }} onClick={() => { signUp() }}>Sign Up</button>
          
        </div>
      </div>
    )
  }


  function landingPage() {
    return (
      <div className="signIn" style={{ height: "100vh", justifySelf:"center",alignSelf:"center", justifyContent: "center",justifyItems:"center" }}>
        <div className="appTitle">
          <h1>Scrolls{subtext("beta")}</h1>
        </div>
        <input style={{ margin: 20, padding: 5 }} value={email} placeholder="email" onChange={e => setEmail(e.target.value)}></input>
        {/* <input type="password" style={{ margin: 20, padding: 5 }} placeholder="password" onChange={e => setPassword(e.target.value)}></input> */}
        <div className="signInGrid">
          {/* <button className="actionButton" style={{ margin: 20, padding: 5 }} onClick={() => { signIn() }}>Sign In</button> */}
          <button className="actionButton" style={{ margin: 20, padding: 5, gridColumn:"span 2"}} onClick={() => { signUpBetaTest() }}>Sign Up To Beta Test</button>
          <button className="actionButton" style={{ margin: 20, padding: 5, gridColumn:"span 2"}} onClick={() => {setDisplayMode(0)}}>Try it out!</button>
          {/* <button className="actionButton" style={{ margin: 20, padding: 5, gridColumn:"span 2"}} >About</button> */}
        </div>
        <div className="about-page">
      <header>
        <h1>About This Project</h1>
      </header>

      <section>
        <div className="about-text">
          <p>
            Welcome!<br></br>Scrolls is a cozy journaling app that helps you capture your thoughts, track your habits, and reflect daily. 
            Simple, minimal, and designed to keep your writing flowing without distractions.
          </p>
          
        </div>

        <div className="about-images">
          {/* <img src={AboutImage1} alt="About Image 1" />
          <img src={AboutImage2} alt="About Image 2" /> */}
        </div>
      </section>


      <footer>

        <p>© 2026 Scrolls. All rights reserved.</p>
      </footer>
    </div>
      </div>
    )
  }

  function aboutPage() {
    return (
      <div className="signIn" style={{ height: "100vh", justifySelf:"center",alignSelf:"center", justifyContent: "center",justifyItems:"center" }}>
        <div className="appTitle">
          <h1>Scrolls{subtext("beta")}</h1>
        </div>
        <input style={{ margin: 20, padding: 5 }} value={email} placeholder="email" onChange={e => setEmail(e.target.value)}></input>
        
        
        <div className="signInGrid">
          {/* <button className="actionButton" style={{ margin: 20, padding: 5 }} onClick={() => { signIn() }}>Sign In</button> */}
          <button className="actionButton" style={{ margin: 20, padding: 5, gridColumn:"span 2"}} onClick={() => { signUpBetaTest() }}>Sign Up To Beta Test</button>
          <button className="actionButton" style={{ margin: 20, padding: 5, gridColumn:"span 2"}} >About</button>

          
        </div>
      </div>
    )
  }

  function paywall() {
  return (
    <div className="paywall">

      <h1>A calmer place for your thoughts 🌙</h1>

      <p>
        Upgrade to Pro and unlock your full journaling space.
      </p>

      <ul>
        <li>✨ Unlimited entries</li>
        <li>📊 Mood insights</li>
        <li>🏷️ Tag your memories</li>
        <li>🎨 Cozy themes</li>
      </ul>

      <button onClick={()=>subscribe()}>
        Upgrade – $5/month
      </button>

      <p className="cancel">
        Cancel anytime
      </p>

    </div>
  );
}

function subscribe(){

}

  function bookSelection() {
    if (journals != null) {
      return (
        <>
          {/* <div style={{ height: "fit-content" }} className="journalItem" >
              <h1>Scroll Name</h1>
              <h2>Members</h2>
              <h2>Last Edited</h2>
          </div> */}
          <div className="journalGrid">

            {journals.map((item: any, i: number) => {
              if (item.ownerid == user.id) {
                return (<div className="journalItem" key={i}>
                  <h1>{item.journal_name}</h1>
                  <button className="actionButton" style={{ marginTop: 0 }} onClick={() => { setCurrentJournal(item.journalid); setCurrentPage("mainApp") }}>Open</button>
                  <button className="actionButton" style={{ marginTop: 0 }} onClick={() => { setCurrentJournal(item.journalid); setCurrentPage("manageMembers") }}>Manage Members</button>
                  <button className="dangerButton" style={{ marginTop: 0 }} onClick={() => deleteScroll(item.journalid)}>Burn</button>
                </div>)
              } else {
                return (<div className="journalItem" style={{ backgroundColor: "red" }} key={i}>

                  <h1>{item.journal_name}</h1>
                  <button className="actionButton" style={{ marginTop: 0 }} onClick={() => { setCurrentJournal(item.journalid) }}>Open</button>
                  {/* <button className="actionButton" style={{ marginTop: 0 }} onClick={() => { setCurrentJournal(item.journalid) }}>Manage Members</button>
                <button className="dangerButton" style={{ marginTop: 0 }} onClick={() => deleteScroll(item.journalid)}>Burn</button> */}
                </div>)

              }


            })}
          </div>
        </>
      )
    } else {
      return (<h1>No Journals</h1>)
    }
  }

  function sideBarButtons() {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignContent: "space-evenly", minHeight: "100%" }}>
        {/* <div className="appTitle"> */}
        <h1>Scrolls{subtext("beta")}</h1>
        {/* </div> */}
        <button className="actionButton" onClick={() => { setCurrentPage("myScrolls"); setCurrentJournal(null); setBubbleData([]); setPublic(false); }} >My Scrolls</button>
        <button className="actionButton" onClick={() => { setCurrentPage("sharedScrolls"); setCurrentJournal(null); setBubbleData([]); setPublic(false); }}>Shared Scrolls</button>
        {/* <button className="actionButton" onClick={() => {setCurrentPage("sharedScrolls"); setCurrentJournal(null); setBubbleData([]); setPublic(true); }} >Community Scrolls</button> */}
        {/* <button className="actionButton" onClick={() => { setCurrentJournal(null); setBubbleData([]); setCurrentPage("paywall"); }} >Upgrade</button> */}
        <button className="actionButton" onClick={() => { setCurrentJournal(null); setBubbleData([]); setCurrentPage("feedback"); }} >Feedback</button>
        {/* <button className="actionButton" onClick={() => { setCurrentJournal(null); setBubbleData([]) }} >Account Settings</button> */}
        {signOutButton()}
        {
          (function () {
            if (currentJournal) {
              return (<>
                {/* <button className="actionButton" onClick={() => exportData()} style={{ backgroundColor: colors["export"]?.[1] }}>Export</button>
                <button className="actionButton" onClick={() => getPrompt()} style={{ backgroundColor: colors["prompt"]?.[1] }}>Get Prompt</button> */}
              </>)
            }
            // ...
          })()
        }
      </div>
    )
  }

  async function createScroll() {
    var newScrollName = prompt("Enter a Name");
    // var publicStatus = window.confirm("Would you like this scroll to be public?");
    var d = new Date();
    const [date, time] = d.toLocaleString("sv-SE").split(" ")
    var publicStatus = false
    if (newScrollName) {
      const { data, error } = await client.from('journalstousers').insert({
        ownerid: user.id,
        journal_name: newScrollName,
        public: publicStatus,
        date:date,
        time:time
      });

      if (error) {
        alert("error creating scroll")
      } else {
        loadJournals();
      }
    }
  }

  async function deleteScroll(scrollID: string) {
    var confirmation = window.confirm("Are you sure you wish to delete this scroll?")
    if (confirmation) {
      const { data, error } = await client.from('journalstousers').delete().eq('journalid', scrollID).eq('ownerid', user.id)
      if (error) {
        alert("Error deleting scroll")
      } else {
        alert("Successfully Burned Scroll")
        loadJournals();
      }
    }
  }

  function searchBarButtons() {
    if (!currentJournal) {
      return (
        <>
          <button className="actionButton" style={{ margin: 0, backgroundColor: colors["export"]?.[1], gridColumn: "span 2" }} onClick={() => createScroll()}>Create Scroll</button>
          {/* <button className="actionButton"  style={{ margin:0,backgroundColor: colors["export"]?.[1],gridColumn:"span 2"}}>Delete Scroll</button> */}
        </>
      )
    } else {
      return (
        <>
          <button className="actionButton" style={{ margin: 0, backgroundColor: colors["export"]?.[1], gridColumn: "span 2" }} onClick={()=>setCurrentPage("manageMembers")}>Manage Members</button>
          {/* <button className="actionButton" style={{ margin: 0, backgroundColor: colors["export"]?.[1], gridColumn: "span 1" }}>Scroll Info</button> */}
          <button className="actionButton" onClick={() => exportData()} style={{ margin: 0, backgroundColor: colors["export"]?.[1] }}>Export</button>
          {/* <button className="actionButton" onClick={() => getPrompt()} style={{ margin: 0, backgroundColor: colors["prompt"]?.[1] }}>Get Prompt</button> */}
        </>
      )
    }
  }
  const [feedbackText, setFeedbackText] = useState<any>();


  function feedBackPage() {

    async function submitFeedback() {
      var d = new Date();
      const [date, time] = d.toLocaleString("sv-SE").split(" ")
      const returnPackage = await client.from("feedback").insert({
        userid: user.id,
        date: date,
        time: time,
        feedback: feedbackText
      })
      if (returnPackage.error) {
        alert("error submitting feedback");
      } else {
        alert("Feedback Submitted, Thank you!")
        setFeedbackText("");
      }
    }

    return (
      <div style={{ padding: 20 }}>
        <h1>Leave your anonymous feedback here!</h1>
        <div style={{justifySelf:"center",textAlign:"left"}}>
        <h2>Feedback Prompts:</h2>
          <p>what do you like?</p>
          <p>what do you feel is missing?</p>  
          <p>what features would be valuable to you?</p>
        </div>
        <textarea style={{ width: "100%", height: "50vh" }} value={feedbackText} onChange={e => setFeedbackText(e.target.value)} />
        <button className="actionButton" onClick={() => { submitFeedback() }}>Submit Feedback</button>
      </div>
    )
  }

  async function addMember(id:string){
    const {data, error} = await client.from('journalstomembers').insert({journalid:currentJournal,memberid:id})
    if(!error){

    } else {
      alert("error adding member to scroll")
    }
    loadUsers();
  }

  async function removeMember(id:string){
    const {data, error} = await client.from('journalstomembers').delete().eq("journalid",currentJournal).eq("memberid",id);
    if(!error){

    } else {
      alert("error removing member from scroll")
    }
    loadUsers();
  }

  function manageMembers() {
    var currentUserArray:any = []
    var searchedUserArray:any = []
    searchedUsers?.map((item:any,i:number)=>{
      searchedUserArray.push(<div style={{backgroundColor:"red",padding:30,margin:20}}key={i} onClick={()=>addMember(item.user_id)}>{item.username}</div>)
    })

    currentMembers?.map((item:any,i:number)=>{
      currentUserArray.push(<div style={{backgroundColor:"red",padding:30,margin:20}}key={i}>{item.users} <button className="actionButton" onClick={()=>removeMember(item.userid)}>Kick</button></div>)
    })
    
    return (
      <div className="manageMembers"
        style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}
      >
        <div
          style={{ display: "flex", flexDirection: "column", gap:10, minHeight:"80vh",maxHeight:"80vh", overflow:"auto"}}
        >
          {searchedUserArray}
        </div>
        <div
          style={{ backgroundColor:"white", display: "flex", flexDirection: "column", gap:10, minHeight:"80vh",maxHeight:"80vh", overflow:"auto"}}
        >
          <h1 style={{color:"black"}}>Current Members</h1>
          {currentUserArray}
        </div>
        <button className="actionButton" style={{gridColumn:"span 2"}}onClick={()=>setCurrentPage("mainApp")}>Back</button>
      </div>


    )
  }

  function innerApp() {
    return (
      <div style={{ display: "grid", gridTemplateColumns: "1fr 11fr", minWidth: "100vw", maxWidth: "100vw" }}>
        <div style={{ backgroundColor: "#00000024", display: "flex", flexDirection: "column", minHeight: "100vh", justifyContent: "center" }}>
          {sideBarButtons()}
        </div>
        <div>
          <div style={{ maxHeight: 80, height: "fit-content", display: "grid", gridTemplateColumns: "5fr 1fr 1fr 1fr 1fr 1fr", gap: 10 }} className="topBar">
            <input className="searchBar" onChange={e => { setSearchTerm(e.target.value) }} value={searchTerm} type="text" placeholder='Search' style={{ backgroundColor: "transparent", color: "white", margin: 0, boxSizing: "border-box", height: "100%", width: "100%" }}></input>
            {searchBarButtons()}
          </div>
          {
            (function () {
              if (currentJournal) {
                switch (currentPage) {
                  case "mainApp":
                    return (
                      mainApp()
                    )
                    break;
                  case "manageMembers":
                    // var userArray:any = []
                    // {searchedUsers?.map((item:any,i:number)=>{
                    //     userArray.push(<p key={i} onClick={()=>alert(item.user_id)}>{item.username}</p>)
                    //   })}
                    return (
                      <>
                      {manageMembers()}
                      {/* {userArray} */}
                      </>
                    )
                    break;
                  default:
                    return (
                      mainApp()
                    )
                    break;
                }
              } else {
                switch (currentPage) {
                  case "myScrolls":
                    return (bookSelection())
                  case "sharedScrolls":
                    return (bookSelection())
                  case "feedback":
                    return (feedBackPage())
                  case "paywall":
                    return(paywall())
                  default:
                    return (<div>Error</div>)
                }
              }
              // ...
            })()
            // currentJournal ? mainApp() : bookSelection()
          }
        </div>
      </div>
    )
  }

  function display() {
    if (displayMode == 1) {
      return (innerApp());
    } else {
      if(displayMode == 0){
                 return (signInScreen());

      } else {
                 return (landingPage());

      }
    }
  }

  return (
    <div className="App">
      {
        display()
      }
    </div>

    // <div className="App" style={{display:"flex", flexDirection:"column", minHeight:"100vh"}}>
    //   <div style={{alignContent:"center", width:"80%",maxWidth:"80%", marginLeft:"10%",minHeight:"30vh",maxHeight:"60vh", overflowY:"scroll", overflowX:"hidden", border:"1px solid black", display:"flex", flexDirection:"column",marginTop:"30px"}}>
    //     {
    //       textBubbles()
    //     }
    //   </div>
    //   <div style={{alignContent:"center", width:"80%", marginLeft:"10%"}}>
    //     {/* <textarea value={textEntry} onChange={e=> {setTextEntry(e.target.value);}}style={{ width: '100%', height: '50vh' }}>
    //     </textarea> */}
    //     {
    //     coloredTextArea()
    //     }
    //     <button onClick={()=>submit()} >Submit</button>
    //     <button onClick={()=>showStorage()} >Storage Test</button>
    //     <button onClick={()=>loadfromDatabase()}>Load From Database</button>
    //   </div>
    // </div>
  );
}

export default App;

/*
Scrolls(beta) -- Cozy Journaling and Shared Journals for Couples

Simple, Fast, Powerful sorting -- Journaling and thought organization that removes the barriers to getting thoughts on a page


Purely Text Based

Single Entry Portal -- Lower the barrier to journaling -- Get thoughts on a page and sort through it later!
Automatic Logging of the data needed to sort through your thoughts later on
Write first, sort later with powerful search, query, tagging, and export capabilities

Need a new channel? Make a new scroll and title it what you want!

Private Scrolls (Live only on your device in local storage)
Drag and Drop a private scroll file from your computer to open that scroll in the web browser

Infinite Scroll in your Scroll

Your data in your control: Export your scroll at any time into JSON and CSV formats.


Visualize Your Entries!
  See your Entries in a graph!


Stretch Goals:
Free local usage and local offline login

Community Scrolls -- Multiplayer Thoughts!
Find common interests
Propose new Categories

SUBSCRIPTION FEATURES:
  Subscription for More than 5 Scrolls

  
  Create shared journals for more than 2 people (significant other?) with an active subscription
    (any shared journals created during the subscription period stay active even after the subscription lapses)
    Shared Journal FEATURES:
      Submit prompts to the rest of the journal members



      Automatic Export (Monthly Export would be Free, but other frequencies require subscription)
  

*/

/*
int=n, List[List[Int]]


prereqs 0 -> n-1

Nodes;
Directional Edges; 


0 is Prereq for 1 
Had to be at Node 0 to get to Node 1

but if 1 is pre-req for 2
that means 0 is also pre-req for 2

So you get this setup:
[1,0]
[2,0]
[2,1]

0 --> 1 --> 2 
--> 2

0 --> 1 
*/